<template>
	<div class="intern">
		<div class="header" style="background: white;">
			<div class="container">
				<div class="flex">
					<div class="logo"><img src="../image/zsdb_logo.png" class="logoImg" style="width:132px"></div>
					<div class="menu" id="nav">
						<ul>
							<li class="menulist"><a @click="gotoHome()" class="">首页</a></li>
							<li class="menulist"><a @click="gotoCampus()" class="">校园招聘</a></li>
							<li class="menulist"><a @click="gotoSociety()" class="">社会招聘</a></li>
							<li class="menulist"><a class="on">实习生招聘</a></li>
						</ul>
					</div>
					<div class="user">
						<div v-show="islogin" class="isLogin" style="display: none;">
							<div @click="gotopersonal()" style="cursor: pointer;"><span>个人中心</span></div>
							<span class="divider">|</span>
							<div @click="exit()" style="cursor: pointer;"><span> 退出</span></div>
						</div>
						<div v-show="unlogin" class="unLogin" style="display: none;">
							<div @click="gotologin()" style="cursor: pointer;"><span>登录</span></div>
							<span class="divider">|</span>
							<div @click="gotoregister()" style="cursor: pointer;"><span>注册</span></div>
						</div>
					</div>
					<el-popover class="ewm" trigger="hover" placement="bottom">
						<img src="../image/ewm.jpg" class="code">
						<img src="../image/icoewm.png" slot="reference" class="ico">
					</el-popover>

				</div>
			</div>
		</div>

		<div class="pagesbanner">
			<img src="../image/sxsdh01.png" class="dh wow  fadeInLeft" style="left: 0">
			<img src="../image/xydh02.png" class="dh wow  fadeInLeft" style="right: 0">
			<div class="text">
				<h3>实习生招聘</h3>
				<p>intern recruitment</p>
			</div>
		</div>
		<a name="zw" style="position: relative;top: -80px;"></a>
		<div class="nidrpages">
			<div class="searchbody">
				<div class="search">
					<el-input v-model="input" placeholder="请输入职位关键词"></el-input>
					<button class="search_btn" @click="jobsearch()"><img src="../image/search.png"></button>
				</div>
			</div>
			<div class="joblistbody">
				<jobinfo v-for="(item,index) in campusjobinfo" :key="index" :campusjobinfo="item"
					v-on:transferpositionID='transferpositionID' v-show="haveshowposition" style="display: none;">
				</jobinfo>
				<div class="noneposition" v-show="noneshowposition" style="display: none;">
					<img src="../image/noneposition.png" class="nonepositionimg" /><br />
					<span class="nonepositiontext">暂无岗位</span>
				</div>
			</div>
		</div>
		<backtop></backtop>
	</div>
</template>

<script>
	import jobinfo from "../components/jobinfo.vue"
	import backtop from "../components/backtop.vue"
	import {
		loginstatus,
		Logout,
		queryPosition,
		collectPosition,
		requestPosition,
	} from '../api/user.js'
	// @ is an alias to /src
	export default {
		components: {
			jobinfo,
			backtop,
		},

		data() {
			return {
				campusjobinfo: [],
				input: '',
				islogin: false,
				unlogin: false,
				haveshowposition: false,
				noneshowposition: false,
				userId: '',
			}
		},

		mounted() {
			loginstatus().then((res) => {
				if (res.code == 200) {
					this.islogin = true;
					this.unlogin = false;
					this.userId = res.data;
				} else if (res.code != 200) {
					this.islogin = false;
					this.unlogin = true;
				}
			});

			queryPosition({
				positionName: "",
			}).then((res) => {
				var i = 0
				var j = 0
				var arr = new Array()
				for (i; i < res.data.length; i++) {
					if (res.data[i].type == 2) {
						arr[j] = res.data[i]
						j++
					}
				}
				if (arr.length != 0) {
					this.campusjobinfo = arr
					this.haveshowposition = true
					this.noneshowposition = false
				} else {
					this.haveshowposition = false
					this.noneshowposition = true
				}
			});
		},

		methods: {
			transferpositionID(transferpositionID) {
				if (transferpositionID.type == 0) {
					collectPosition({
						positionID: transferpositionID.positionID,
						userID: this.userId,
					}).then((res) => {
						if (res.code == 200) {
							this.$message({
								message: '收藏成功！',
								type: 'success'
							});
						} else {
							this.$message({
								message: '收藏失败！',
								type: 'error'
							});
						}
					});
				} else if (transferpositionID.type == 1) {
					requestPosition({
						positionID: transferpositionID.positionID,
						userID: this.userId,
						order: transferpositionID.order
					}).then((res) => {
						if (res.code == 200) {
							this.$message({
								message: '投递成功！',
								type: 'success'
							});
						} else if (res.code == 40098) {
							this.$message({
								message: '简历不存在！',
								type: 'error'
							});
						} else if (res.code == 40099) {
							this.$message({
								message: '简历类型与所投岗位类型不匹配！',
								type: 'error'
							});
						} else if (res.code == 50099) {
							this.$message({
								message: '岗位不存在！',
								type: 'error'
							});
						} else if (res.code == 40002) {
							this.$message({
								message: '用户已申请两个岗位，请调整！',
								type: 'error'
							});
						} else if (res.code == 40003) {
							this.$message({
								message: '此位置申请已存在！',
								type: 'error'
							});
						}
					});
				}
			},
			exit() {
				Logout().then((res) => {
					location.reload()
				})
			},
			gotologin() {
				this.$router.push('/login')
			},
			gotoregister() {
				this.$router.push('/register')
			},
			gotoHome() {
				this.$router.push('/')
			},
			gotoAboutus() {
				this.$router.push('/aboutus/introduce')
			},
			gotoCampus() {
				this.$router.push('/campus')
			},
			gotoSociety() {
				this.$router.push('/society')
			},
			// gotoIntern() {
			// 	this.$router.push('/intern')
			// },
			jobsearch() {
				queryPosition({
					positionName: this.input,
				}).then((res) => {
					var i = 0
					var j = 0
					var arr = new Array()
					for (i; i < res.data.length; i++) {
						if (res.data[i].type == 2) {
							arr[j] = res.data[i]
							j++
						}
					}
					if (arr.length != 0) {
						this.campusjobinfo = arr
						this.haveshowposition = true
						this.noneshowposition = false
					} else {
						this.haveshowposition = false
						this.noneshowposition = true
					}
				});
			},
			gotopersonal() {
				this.$router.push('/personal/resume')
			},
		}
	}
</script>

<style scoped>
	@import url(../assets/css/index.css);

	.searchbody {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		width: 1150px;
		height: 70px;
		margin-left: 25%;
		background-color: white;
		border-radius: 30px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
		padding-top: 14px;
		padding-left: 55px;
	}

	.search {
		display: flex;
		width: 90%;
	}

	.joblistbody {
		background-color: white;
		width: 1150px;
		margin-top: 35px;
		margin-left: 25%;
		border-radius: 2px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
	}

	.search_btn {
		background-color: #0056b1;
		width: 100px;
		height: 40px;
		margin-left: 25px;
		border: none;
		cursor: pointer;
	}

	.pagesbanner {
		background: url(../image/bannersxs.jpg) top center no-repeat;
	}
</style>
